import React from 'react';
import { IStepProps } from '../Step.component';

export const isStepChild = (child: React.ReactNode): child is React.ReactElement<IStepProps> => {
  return (
    React.isValidElement(child) &&
    (React.isValidElement((child.props as IStepProps).title) || typeof (child.props as IStepProps).title === 'string')
  );
};
